import Admin from 'Components/Guards/Admin';

export default {
    'admin': Admin
};
